import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import instructions from "../../assets/images/mfa/microsoftqr.png";
import { SubTitle, Title } from "./styles";
import { ButtonPrimary } from "../../ui/buttons";
import "./styles.css";

function InstructionAppModal({ toggle, isOpen, handleNextModal }) {
  const handleContinuar = () => {
    handleNextModal();
    // toggle();
  };
  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle} centered contentClassName="custom-modal">
        <ModalHeader className="border-0 p-0 pb-2" toggle={toggle} />
        <ModalBody className="p-0">
          <>
            <Title>Habilitar autenticación de dos factores</Title>
            <SubTitle className="mb-4">
              {' Una vez en la aplicación selecciona "+" y luego "Otra cuenta" o selecciona el icono de "Id. comprobado" para escanear el código QR.'}
            </SubTitle>
            <img className="lazyloaded" src={instructions} alt="icono authenticator" style={{ width: "50%", margin: "0px auto 30px" }} />
          </>
        </ModalBody>
        <ModalFooter className="border-0 pt-0">
          <Button color="btn-secondary mr-2" onClick={toggle} style={{ height: "40px" }}>
            Cancelar
          </Button>
          <ButtonPrimary onClick={handleContinuar}>Continuar</ButtonPrimary>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default InstructionAppModal;
